/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wild_Wide_Snake_HoldInputs */

const en_wild_wide_snake_hold = /** @type {(inputs: Wild_Wide_Snake_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow comments`)
};

const de_wild_wide_snake_hold = /** @type {(inputs: Wild_Wide_Snake_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentare erlauben`)
};

/**
* | output |
* | --- |
* | "Allow comments" |
*
* @param {Wild_Wide_Snake_HoldInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wild_wide_snake_hold = /** @type {((inputs?: Wild_Wide_Snake_HoldInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wild_Wide_Snake_HoldInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wild_wide_snake_hold(inputs)
	return de_wild_wide_snake_hold(inputs)
});